import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const Dashboard = React.lazy(() => import("./Dashboard"));
const ProjectList = React.lazy(() => import("./ProjectList"));
const NewProject = React.lazy(() => import("./NewProject"));
const ProjectDetails = React.lazy(() => import("./ProjectDetails"));
const EditProject = React.lazy(() => import("./EditProject"));
const EOIList = React.lazy(() => import("./EOIList"));

const investmentProjectsModuleConfig: ModuleConfig = {
  id: "investment-projects",
  name: "Investment Projects",
  description: "Showcase investable businesses and manage expressions of interest",
  version: "1.0.0",
  enabled: true,
  category: "investment",
  order: 2,
  icon: "🏗️",
  color: "#3182CE",

  routes: [
    { path: "/investment-projects", component: Dashboard, permissionLevel: "view" },
    { path: "/investment-projects/list", component: ProjectList, permissionLevel: "view" },
    { path: "/investment-projects/new", component: NewProject, permissionLevel: "create" },
    { path: "/investment-projects/eois", component: EOIList, permissionLevel: "view" },
    { path: "/investment-projects/:id", component: ProjectDetails, permissionLevel: "view" },
    { path: "/investment-projects/:id/edit", component: EditProject, permissionLevel: "edit" },
  ],

  navigation: [
    { label: "Marketplace", path: "/investment-projects", icon: "🏪", permissionLevel: "view" },
    { label: "All Projects", path: "/investment-projects/list", icon: "📋", permissionLevel: "view" },
    { label: "New Project", path: "/investment-projects/new", icon: "➕", permissionLevel: "create" },
    { label: "EOIs", path: "/investment-projects/eois", icon: "📨", permissionLevel: "view" },
  ],

  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
  },

  quickActions: [
    {
      label: "New Project",
      path: "/investment-projects/new",
      icon: "➕",
      description: "Create a new investable project",
    },
  ],

  changelog: [
    {
      version: "1.0.0",
      releaseDate: "2026-02-27",
      title: "Initial Release - Investment Projects Marketplace",
      features: [
        "Create and manage investable projects",
        "Public marketplace with sector/visa filters",
        "QLD Government compliance checklist",
        "Expression of Interest (EOI) system",
        "Team members and document management",
        "Financial details and funding progress",
      ],
      notes: "MVP release for Vanguard IQ investment project marketplace.",
    },
  ],

  roadmap: [],
};

export default investmentProjectsModuleConfig;
